module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 23
// module chunks = 0